// import {log} from "./logger-dom.js";
// import {loader, vars} from "./variables-loader.js";
// import {loader} from "./variables-loader";

const menu_style = document.createElement('style');
menu_style.innerHTML = `

.fantastic-element-grid{
    display: grid;
    grid-template-columns: 16px 16px auto auto;
    grid-template-rows: auto;
    grid-auto-flow: row dense;
    color: inherit;
}

.fantastic-element-row{
    display: contents;
    color: inherit;
    overflow: auto;
}

.fantastic-element-key{
    padding-right: 2em;
}

.fantastic-element-row div.drag-state{
    opacity:0.5;
}

.fantastic-element-key:before {
    content: attr(data-before);
    font-size:9px;
    margin-right: 2px;
    opacity:0.8;
    display: none;
}

.fantastic-element-handle{
    padding: 2px 4px;
    display: block;
    color: inherit;
    font-size:9px;
    text-align:center;
    width:auto;
}

/*
.fantastic-element-handle:after{
  content: attr(id);
  color: #c33;
}
*/

.fantastic-element-handle:hover{
    color:white;
    background: black;
}

.fantastic-element-icon, .fantastic-element-handle{
    cursor:pointer;
}



.fantastic-element-key, .fantastic-element-value{
    cursor:pointer;
    /*border-color: inherit;display: inline-block; margin: 2px 0;border-top: 1px dotted;*/
}

input[type=number] { 
    -moz-appearance: textfield;
    appearance: textfield;
    margin: 0; 
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
}

.fantastic-selecta {
    display:inline-block;
}


.fantastic-selecta input {
    font-family: inherit;
    border:none;
    background: none;
    margin:0;
    padding:0;
    color:inherit;
    font-size:inherit;
    text-align:left;
    width:100%;
}


.fantastic-selecta input.float {
    text-align:center;
    width:12em;
}

input:focus, textarea:focus {
    outline: none;
}

.fantastic-selecta span{
    box-sizing: border-box;
    margin: 0 2px;
}

.fantastic-selecta span.inert-button{
    pointer-events: all;
    cursor: pointer;
}

#summary{
    white-space:pre;
}

`;

document.head.appendChild(menu_style);

let main_obj;
let modified_callback;
let element_counter = 0;
let indices = [[0,'root'], 0, 0, 0, 0, 0];
let lex_indices = [0, 0, 0, 0, 0, 0];

const addresses = {};

const state = ['none', 'contents'];
const state_icon = ['+', '—'];
const reserved = ['params', 'value', 'type', 'select', 'index', 'float', 'max', 'min', 'increment', 'array-special', 'float-special','session-name','clock','target','function'];
const date = new Date(Date.now()).toISOString().slice(0, 19).replace('T', ' ');

const fantastic_menu = document.createElement('div');
fantastic_menu.setAttribute('id', 'fantastic-menu');
fantastic_menu.className = 'fantastic-element-grid';

const select_edit = document.createElement('div');
select_edit.classList.add('fantastic-selecta');

const summary = document.createElement('div');
summary.setAttribute('id', 'summary');
summary.className = 'div-base';
summary.innerHTML = date;


const var_types = ['boolean', 'number', 'string', 'array', 'object', 'array-special', 'float-special'];

const get_children = (t_id) => document.querySelectorAll(`div[data-parent="${t_id}"]`);
const get_element = (el_data_id) => document.querySelector(`div[data-id="${el_data_id}"]`);

function get_dom_parent(node) {
    const parent_node = document.querySelector(`div[data-id="${node.getAttribute('data-parent')}"]`);
    if (!parent_node) return false;
    if (parent_node.hasAttribute('data-special')) return parent_node;
    return get_dom_parent(parent_node);
}

const get_closest_special = (element) => {
    let n = element.parentNode;
    while (n = n.previousElementSibling) {
        if (n.getAttribute('data-special')) return n;
    }
    return null;
}

const get_closest_special_attrib = (element, attrib) => {
    let n = element.parentNode;
    while (n = n.nextElementSibling) {
        if (n.querySelector('.fantastic-element-key').textContent.indexOf(attrib) !== -1) return n;
    }
    return null;
}

function refresh_list() {
    [...fantastic_menu.children].map(ec => {
        const par = fantastic_menu.querySelectorAll(`div[data-id="${ec.getAttribute('data-parent')}"]`)[0];
        if (par !== undefined) {
            const is_open = parseInt(par.getAttribute('data-open'));
            ec.style.display = par.style.display === 'none' ? 'none' : state[is_open];
        }
    });
}

function rec_children(t_id, close=true, furry=[]) {
    const children = get_children(t_id);
    for (let c of children) {
        furry.push(c);
        if(close) c.style.display = state[0];
        const c_id = c.getAttribute('data-id');
        const next_children = get_children(c_id);
        if (next_children.length) rec_children(c_id, close, furry);
    }
    return furry[furry.length-1];
}

const selecta = {
    element: null,
    element_text: null,
    selected: null,
    increment_state: false,
    increment_decimal: 0,
    editors: {},
    float_special_template: () => {
        const obj = {
            "params": {
                "type": "float-special",
                "float": 0,
                "max": 100.0,
                "min": 0.0,
                "increment": 1,
            }
        }
        Object.defineProperty(obj, 'value', {
            get() {
                return obj.params.float
            }
        });
        return obj;
    },
    array_special_template: () => {
        const obj = {
            "params": {
              "type": "array-special",
              "select": ['default'],
              "index": 0
            }
        }
        Object.defineProperty(obj, 'value', {
            get() {
                return obj.params.select[obj.params.index]
            }
        });
        return obj;
    },
    notify_obj_delta(notice, is_special = null) {
        if (modified_callback) {
            const path = [selecta.element.parentNode.getAttribute('data-id'), notice.type, selecta.element.param];
            path.push(notice);
            return modified_callback(path);
        }
    },
    increment(e) {
        //e.preventDefault();
        //e.stopPropagation();
        const el_kp = selecta.element.parentNode.param;

        function repeater() {
            const dir = e.target.getAttribute('value') === 'max' ? 1 : -1
            const kp = el_kp.obj[el_kp.k].params;

            const input = e.target.parentNode.querySelector('input');
            const value = (Number(input.value) + (dir * kp.increment));
            if (value >= kp.min && value <= kp.max) {
                input.value = value.toFixed(selecta.increment_decimal);
                input.select();
                selecta.increment_state = setTimeout(repeater, 1000 * kp.increment);
            } else {
                clearTimeout(selecta.increment_state);
            }
        }

        if (e.type === 'mousedown') {
            repeater()
        } else {
            clearTimeout(selecta.increment_state);
            selecta.modify(e, true);
        }
        e.preventDefault();
        e.stopPropagation();
    },
    re_fix() {
        // reset dom id_s because they're derived from key index in object.
        [...fantastic_menu.children].map(c => {
            const aux_id = c.getAttribute('data-parent') + '_' + Object.keys(c.param.obj).indexOf(c.param.k)
            c.querySelector('.fantastic-element-key').setAttribute('data-before', `[${c.getAttribute('data-id')}:${aux_id}]`);
            c.querySelector('.fantastic-element-value').setAttribute('id', aux_id);
        });
    },
    rename(element_row, new_name, is_restore = null) {
        let n = new_name;
        const base_obj = element_row.obj;
        //save order systems
        //#// HAVE TO REPLACE ALL OF THESE REFS DYNAMICALLY BECAUSE BAD ORDER IS STORED ON ELEMENT OBJECT. ss? /s probs not.
        // this IS where ths issue is...not preserving new order.
        // const k_perfect = {};
        // k_perfect[base_obj.id] = keys;

        const keys = menu.ordering_dict.hasOwnProperty(base_obj.id) ? menu.ordering_dict[base_obj.id] : Object.keys(base_obj);
        keys.splice(keys.indexOf(element_row.k), 1, new_name);
        menu.ordering_dict[base_obj.id] = keys;

        console.log('ORDER 🖐', menu.ordering_dict);
        //https://unicode.org/emoji/charts/full-emoji-list.html
        //❎,➡,	🖐,🖐

        if (element_row.pseudo) {
            n = '_' + new_name;
            console.log('👉️', element_row.k, n);
            base_obj[n] = base_obj[element_row.k];
            delete base_obj[element_row.k];
            console.log('👉️ has pseudo_element', element_row.pseudo);
            delete base_obj[element_row.pseudo];
            element_special_create_pseudo(base_obj, n, new_name);
            element_row.pseudo = new_name;
        } else {
            base_obj[new_name] = base_obj[element_row.k];
            delete base_obj[element_row.k];
        }

        if (!is_restore) selecta.notify_obj_delta({
            'type': 'rename',
            'old_name': element_row.k,
            'new_name': n,
            'special': element_row.hasOwnProperty('pseudo')
        });

        element_row.k = n;
        selecta.re_fix();


        //console.log('WHAT 👉️', element_row.obj);
        // //const obj = selecta.selected.obj;//[selecta.selected.k];
        // selecta.selected.obj[new_name] = selecta.selected.obj[selecta.selected.k];
        // delete selecta.selected.obj[selecta.selected.k];

        return n;
    },
    create(e, is_restore = null) {
        if (e.target) {
            e.preventDefault();
            e.stopPropagation();
        }

        const element_auto_value = e.target.value;
        const c_element = e.target ? e.target.param.parentNode : e.parentNode;
        const element_type = e.target ? e.target.getAttribute('type') : c_element.param.type;
        const base_obj = c_element.param;

        const this_obj = base_obj.obj[base_obj.k] ? base_obj.obj[base_obj.k] : base_obj.obj;

        // if(!this_obj)

        console.log('create @', this_obj);

        const keys = menu.ordering_dict.hasOwnProperty(this_obj.id) ? menu.ordering_dict[this_obj.id] : Object.keys(this_obj);

        const lookup = c_element.getAttribute('data-id');
        const children = get_children(lookup);

        let element_key = null;
        let element_value = null;
        let multiple_elements = null;

        if (element_type === 'array-auto') {
            element_key = children.length;
            element_value = element_auto_value;///'Untitled-' + (element_counter + 1);
            this_obj.push(element_value);
        }

        if (element_type === 'array') {
            element_key = 'Untitled-' + (element_counter + 1);
            element_value = null;
            this_obj[element_key] = [];
        }

        if (element_type === 'string') {
            element_key = 'Untitled-' + (element_counter + 1);
            element_value = 'string';
            this_obj[element_key] = element_value;
        }

        if (element_type === 'number') {
            element_key = 'Untitled-' + (element_counter + 1);
            element_value = 0;
            this_obj[element_key] = element_value;
        }

        if (element_type === 'boolean') {
            element_key = 'Untitled-' + (element_counter + 1);
            element_value = false;
            this_obj[element_key] = element_value;
        }

        if (element_type === 'object') {
            element_key = 'Untitled-' + (element_counter + 1);
            element_value = null;
            this_obj[element_key] = {};
        }

        if (element_type === 'float-special') {
            const new_float = selecta.float_special_template();
            element_key = '_float_' + (element_counter + 1);
            element_value = null;
            this_obj[element_key] = new_float;

            multiple_elements = [element(element_key, element_value, this_obj, lookup, lookup + '_' + children.length, base_obj.lvl + 1, true)];
            indices[base_obj.lvl + 1] = element_counter-1;
            get_list(this_obj[element_key], base_obj.lvl + 2).map(el => multiple_elements.push(el));
        }

        if (element_type === 'array-special') {
            const new_array = selecta.array_special_template();
            element_key = '_array_' + (element_counter + 1);
            element_value = null;
            this_obj[element_key] = new_array;

            multiple_elements = [element(element_key, element_value, this_obj, lookup, lookup + '_' + children.length, base_obj.lvl + 1, true)];
            indices[base_obj.lvl + 1] = element_counter-1;
            get_list(this_obj[element_key], base_obj.lvl + 2).map(el => multiple_elements.push(el));
        }

        //console.log(multiple_elements);

        if (element_key !== null) {

            keys.push(element_key);
            menu.ordering_dict[base_obj.id] = keys;

            const after_div = children.length ? rec_children(c_element.getAttribute('data-id'), false) : c_element;

            if(multiple_elements) {
                multiple_elements.map((el, i) =>{
                    const ref = !multiple_elements[i-1] ? after_div : multiple_elements[i-1];
                    ref.after(el);
                })

            }else{
                const new_element = element(element_key, element_value, this_obj, lookup, lookup + '_' + children.length, base_obj.lvl + 1, null);
                after_div.after(new_element);
            }

            if (!is_restore) selecta.notify_obj_delta({
                'type': 'create',
                'element_type': element_type,
                'element_key': element_key,
                'element_value': element_value
            });
        }

        if (!is_restore) selecta.element.textContent = selecta.element_text;
        refresh_list();
    },
    modify(e, incremented = null) {

        e.preventDefault();
        e.stopPropagation();

        if (e.type === 'focus') return false;

        const editor = incremented !== null ? e.target.parentNode.getAttribute('editor-type') : e.target.getAttribute('editor-type');

        let value;
        const el_kp = selecta.element.parentNode.param;


        switch (editor) {
            case 'float':
            case 'number':
                value = Number(e.target.value);
                break;
            case 'string':
                value = e.target.value.toString();
                break;
            case 'boolean':
                value = e.target.getAttribute('value') === 'true';
                break;
            case 'float-special':
                value = Number(e.target.parentNode.querySelector('input').value);
                selecta.selected.obj[el_kp.pseudo] = value;
                break;
            case 'array-special':
                value = e.target.getAttribute('value');
                selecta.selected.obj[el_kp.pseudo] = value;
                break;
            default:
                value = e.target.value;
        }

        /// editor is always string for key-rename
        //, selecta.element.param

        console.log(editor, selecta.selected.k, value);

        if (selecta.selected.k === value || selecta.selected.k === '_' + value || selecta.selected.v === value) {
            console.log('failed');
            return e.target.select();
        }


        if (selecta.element.param === 'key') {
            value = selecta.rename(selecta.selected, value);
            selecta.element_text = selecta.selected.pseudo ? value.slice(1, value.length) : value;
        } else {

            selecta.selected.v = value;
            selecta.element_text = value;

            let pass_down = null;

            if (editor === 'array-special') {
                selecta.element_text = selecta.selected.obj[el_kp.pseudo];
                selecta.element.textContent = selecta.element_text;
                pass_down = get_closest_special_attrib(selecta.element, 'index');
            } else if (editor === 'float-special') {
                const el_param = el_kp.obj[el_kp.k].params;
                selecta.set_editor(selecta.editors[editor], el_param);
                pass_down = get_closest_special_attrib(selecta.element, 'float');
            } else {
                console.log('no special');
                selecta.selected.obj[selecta.selected.k] = value;
                selecta.element.textContent = value;
            }

            if (pass_down) {
                pass_down.param.v = value;
                update_element(pass_down);
            }

            const pass_up = get_closest_special(selecta.element);
            if (pass_up) update_element(pass_up);

            selecta.notify_obj_delta({
                'type': 'modify',
                'element': pass_down ? pass_down.param.k : selecta.element.parentNode.param.k,
                'value': value
            });

        }


        // if (modified_callback) {
        //     const element = pass_down ? pass_down : selecta.element.parentNode;
        //     const path = [selecta.element.parentNode.getAttribute('data-id'), selecta.element.param];
        //
        //     // const path = rec_path(element).reverse();
        //     // path.shift();
        //
        //     if(key_renamed){
        //         path.push(key_renamed[0]);
        //         path.push(['renamed', key_renamed[1], selecta.selected.hasOwnProperty("pseudo")]);
        //     }else{
        //         path.push(element.param.k);
        //         path.push(value);
        //     }
        //
        //     return modified_callback(path);
        // }


    },
    set_editor(editor, value) {
        console.log('set_editor', editor.getAttribute('editor-type'));

        switch (editor.getAttribute('editor-type')) {
            case 'float':
            case 'number':
            case 'string':
                editor.children[0].value = value;
                editor.children[0].select();
                break;
            case 'boolean':
                [...editor.children].map(c => {
                    if (c.getAttribute('value') === value.toString()) {
                        c.classList.add('selected');
                    } else {
                        c.classList.remove('selected');
                    }
                });
                break;
            case 'float-special':
                [...editor.children].map(c => {
                    const item = c.getAttribute('value');
                    if (item === 'float') {
                        c.value = value[item];
                        c.select();
                    } else {
                        c.textContent = value[item];
                    }
                    if (item === 'increment') {
                        const h_dec = value[item].toString().split('.');
                        selecta.increment_decimal = h_dec.length > 1 ? h_dec[1].length : 0;
                    }
                });
                break;
            case 'array-special':
                editor.textContent = '';
                Object.entries(value.select).map(v => {
                    const item = document.createElement('div');
                    item.textContent = v[1].toString();
                    item.setAttribute('value', v[0]);
                    item.setAttribute('editor-type', 'array-special');
                    if (v[0] === value.index.toString()) item.classList.add('selected');
                    item.addEventListener('mouseup', selecta.modify);
                    editor.appendChild(item);
                })
                break;
            case 'object':
                editor.textContent = '';
                var_types.map(t => {
                    const obj_item = document.createElement('div');
                    obj_item.textContent = t;
                    obj_item.setAttribute('type', t);
                    obj_item.addEventListener('mouseup', selecta.create);
                    obj_item.param = selecta.element;
                    editor.appendChild(obj_item);
                });
                break;
            case 'array':
                editor.textContent = '';
                const array_item = document.createElement('input');
                array_item.setAttribute('type', 'array-auto');
                array_item.setAttribute('editor-type', 'array-auto');
                array_item.addEventListener('change', selecta.create);
                array_item.param = selecta.element;
                editor.appendChild(array_item);
                break;
            default:
                break;
        }
        return true;
    },
    make_editor(type) {

        if (this.editors.hasOwnProperty(type)) return this.editors[type];
        console.log('make_editor', type);
        const editor = document.createElement('div');
        editor.setAttribute('editor-type', type);

        switch (type) {
            case 'float':
            case 'number':
                const numeric_item = document.createElement('input');
                //numeric_item.setAttribute('type', 'number');
                numeric_item.setAttribute('editor-type', type);
                numeric_item.addEventListener('change', selecta.modify);
                numeric_item.addEventListener("keyup", function (event) {
                    if (event.key === "Enter") selecta.modify(event);
                });
                editor.appendChild(numeric_item);
                break;
            case 'string':
                const item = document.createElement('input');
                item.addEventListener('change', selecta.modify);
                item.addEventListener("keyup", function (event) {
                    if (event.key === "Enter") selecta.modify(event);
                });
                item.setAttribute('editor-type', type);
                editor.appendChild(item);
                break;
            case 'boolean':
                ['true', 'false'].map(tv => {
                    const item = document.createElement('span');
                    item.textContent = tv;
                    item.setAttribute('value', tv);
                    item.setAttribute('editor-type', type);
                    editor.appendChild(item);
                })
                editor.addEventListener('mouseup', selecta.modify);
                break;
            case 'float-special':
                ['min', 'float', 'max', 'increment'].map(fsp => {
                    let item;
                    if (fsp === 'float') {
                        item = document.createElement('input');
                        item.addEventListener('change', selecta.modify);
                        item.setAttribute('type', 'number');
                        item.setAttribute('editor-type', type);
                        item.classList.add('float');
                    } else {
                        item = document.createElement('span');
                        item.textContent = fsp;
                        if (fsp !== "increment") {
                            item.addEventListener('mousedown', selecta.increment);
                            item.addEventListener('mouseup', selecta.increment);
                            item.classList.add('inert-button');
                        } else {
                            item.classList.add('dark');
                        }
                    }
                    item.setAttribute('value', fsp);
                    editor.appendChild(item);
                })
                break;
            case 'array-special':
                break;
            case 'object':
                break;
            case 'array':
                break;
            default:
                break;
        }

        this.editors[type] = editor;
        return editor;
    },
    attach(element, order, param = null) {
        if (this.element) this.element.textContent = this.element_text;
        this.element = element;
        this.element_text = element.textContent;
        this.selected = param;

        const kp = param.obj[param.k];

        let editor_type;
        let editor_content;

        ///console.log(param);

        if (order === 'key') {
            editor_type = 'string';
            editor_content = param.pseudo ? param.pseudo : param.k;
        } else {
            editor_type = param.pseudo ? kp.params.type : param.type;
            editor_content = param.pseudo ? kp.params : param.v;
        }

        const editor = this.make_editor(editor_type);
        console.log("created editor",editor_type);
        //#//bypass for raw array, automate element creation
        // if (editor_type === 'array') {
        //     selecta.create(element);
        //     console.log("created");
        //     return;
        // }


        this.set_editor(editor, editor_content);

        element.textContent = '';

        [...select_edit.children].map(c => select_edit.removeChild(c));

        select_edit.appendChild(editor);

        element.appendChild(select_edit);

        const has_input = select_edit.querySelector('input')
        if (has_input) {
            has_input.select();
        }
    }
}

function element_event(e) {

    const order = e.target.param;
    if (!order) return false;
    const t_el = e.target.parentNode;
    const open = parseInt(t_el.getAttribute('data-open'));

    if(e.type === 'mouseup'){
        if ((order !== 'value' && order !== 'key' ) || (order === 'key' && !menu.editable) || (e.target.textContent === '(+)' && !open)) {
            const new_state = Math.abs(open - 1);
            t_el.setAttribute('data-open', Math.abs(open - 1).toString());
            if (t_el.param.v === null) t_el.querySelector(".fantastic-element-icon").textContent = state_icon[new_state];
            if (new_state === 0) rec_children(t_el.getAttribute('data-id'));
            refresh_list();
        }

        if (menu.editable){
            if ((order === 'key' || order === 'value' || e.target.textContent === '(+)') && !e.target.hasAttribute('no-edit')) {
                selecta.attach(e.target, order, t_el.param);
            }
        }else{
            if ((order === 'value') && !e.target.hasAttribute('no-edit')) {
                selecta.attach(e.target, order, t_el.param);
            }
        }
    }

    if(order === 'handle'){
        if(e.type === 'mousedown'){
            console.log('confirm mousedown', e.target.id);
            rec_children(t_el.getAttribute('data-id'));
            menu.dragging_active = true;
            menu.dragging_element = e.target;
            menu.dragging_origin_after = e.target.parentNode.previousElementSibling;
            [...t_el.children].map(c => c.classList.add('drag-state'));
        }
        if(e.type === 'mouseup'){
            if(menu.dragging_element === e.target){
                console.log('confirm drag', e.target.id);
                const parent_id = t_el.getAttribute('data-parent');
                const ele_id = t_el.getAttribute('data-id');
                const these = get_children(parent_id);
                const child_elements = get_children(ele_id);

                [...child_elements].map((el, i) =>{
                    const ref = !child_elements[i-1] ? t_el : child_elements[i-1];
                    ref.after(el);
                })

                menu.ordering_dict[parent_id] = [...these].map(c => c.param.k);

            }


            menu.dragging_active = false;
            menu.dragging_element = null;
            [...t_el.children].map(c => c.classList.remove('drag-state'));
        }
    }

}

function update_element(element) {
    const k = element.querySelector(".fantastic-element-key");
    const v = element.querySelector(".fantastic-element-value");
    const kp = element.param;

    if (kp.pseudo) {
        // kp.pseudo = kp.k.slice(1, kp.k.length);
        v.textContent = kp.obj[kp.pseudo];
        k.textContent = kp.pseudo;
        k.style['font-weight'] = '800';
    } else {
        if(menu.editable){
            v.textContent = (kp.v !== null) ? kp.v : '(+)';
        }else{
            v.textContent = (kp.v !== null) ? kp.v : '';
        }

        k.textContent = kp.k;
    }
}

function element_special_variable_delta_callback(var_name = null) {
    //log.log("special variable", var_name, "was changed");
}

function element_special_create_pseudo(obj, key, ref) {

    const casetest = obj[key].hasOwnProperty('params') ? obj[key].params.type : undefined;

    switch (casetest) {
        case 'float-special':
            Object.defineProperty(obj, ref, { //<- This object is called a "property descriptor".
                get() {
                    return this['_' + ref]['params'].float;
                    //return this['_' + ref].float;
                },
                set(val) {
                    this['_' + ref]['params'].float = val;
                    if(menu.modification_callback_function) menu.modification_callback_function(obj, ref, val);
                    //element_special_variable_delta_callback(ref);
                },
                configurable: true,
                //enumerable: true
            });
            Object.defineProperties(obj[key], {
                float: {
                    value: 0.0,
                    writable: false
                }
            });
            break;
        case 'array-special':
            Object.defineProperty(obj, ref, { //<- This object is called a "property descriptor".
                get() {
                    return this['_' + ref]['params'].select[this['_' + ref]['params'].index];
                },
                set(val) {
                    if (isNaN(parseInt(val))) {
                        this['_' + ref]['params'].index = this['_' + ref]['params'].select.indexOf(val);
                    } else {
                        this['_' + ref]['params'].index = parseInt(val);
                    }
                    element_special_variable_delta_callback(ref);
                },
                configurable: true,
                //enumerable: true
            });
            break;
        default:
            Object.defineProperty(obj, ref, { //<- This object is called a "property descriptor".
                get() {
                    return this['_' + ref];
                },
                set(val) {
                    this['_' + ref] = val;
                    element_special_variable_delta_callback(ref);
                },
                configurable: true,
                //enumerable: true
            });
            break;
    }
}

const element = (k, v, obj, p_id, var_id, lvl, flag = null) => {
    const el = document.createElement('div');
    el.classList.add('fantastic-element-row');
    el.param = {menuid: element_counter, k: k, v: v, obj: obj, type: Array.isArray(obj[k]) ? 'array' : typeof v, lvl: lvl};
    el.setAttribute('data-id', element_counter.toString());
    el.setAttribute('data-parent', p_id);
    el.setAttribute('data-open', '0');

    //let element_type = null;
    if (k[0] === '_' && obj[k].hasOwnProperty('params')) { ///has params
        const ref = k.slice(1, k.length);
        el.setAttribute('data-special', 'true');
        element_special_create_pseudo(obj, k, ref);
        el.param.pseudo = ref;
        el.param.type = obj[k].params.type;
        console.log(obj[k]);
    }


    //
    // console.log(el.param.type);
    const d_handle = document.createElement('div');
    const handle_label = element_counter.toString().padStart(2, "0");
    d_handle.classList.add('fantastic-element-handle');
    d_handle.setAttribute('id', 'handle'+handle_label);
    d_handle.param = 'handle';
    d_handle.textContent = handle_label;
    el.appendChild(d_handle);

    const d_icon = document.createElement('div');
    d_icon.classList.add('fantastic-element-icon');
    d_icon.param = 'button';
    if (flag) d_icon.textContent = '+';
    el.appendChild(d_icon);




    [{n: 'key', v: k, o: lvl, e: null}, {n: 'value', v: v, o: 0, e: (typeof v)}].map(d => {
        const d_el = document.createElement('div');

        if (d.n === 'value') d_el.setAttribute('id', var_id);

        d_el.setAttribute('data-before', `[${element_counter}:${var_id}]`);

        d_el.param = d.n;
        d_el.className = `fantastic-element-${d.n}`;
        d_el.style['margin-left'] = (d.o * 10) + 'px';
        if (reserved.includes(d.v) || (d.n === 'key' && !isNaN(parseInt(d.v)))) {
            d_el.setAttribute('no-edit', 'true');
            d_el.style['font-style'] = 'oblique';
        }
        el.appendChild(d_el);
    })

    update_element(el);

    el.addEventListener('mousedown', element_event);
    el.addEventListener('mouseup', element_event);
    //fantastic_menu.appendChild(el);
    element_counter++;

    return el;

}

function get_list(crit, lvl = 0, list=[]) {
    let ict = 0;
    for (let c of Object.keys(crit)) {
        //lex_indices[lvl] = ict;
        const p_id = lvl > 0 ? indices[lvl - 1][0] : 0;
        const var_id = p_id + '_' + ict;
        //
        // console.log(c, element_counter);

        if (typeof (crit[c]) === 'object' && crit[c]) {
            indices[lvl] = [element_counter, c];
            //
            Object.defineProperties(crit[c], {
                menuid: {
                    value: element_counter,
                    writable: false
                },
                menuname:{
                    value: c,
                    writable: false
                },
                menusuper:{
                    value: lvl > 0 ? indices[lvl - 1][1] : 'root',
                    writable: false
                }
            });

            list.push(element(c.toString(), null, crit, p_id, var_id, lvl, true));
			
            get_list(crit[c], lvl + 1, list);
        } else {
			
            //if(crit[c] instanceof Function) crit[c] = 'function';
            list.push(element(c.toString(), crit[c], crit, p_id, var_id, lvl));
        }
        ict++;
    }
    return list;
}

const menu = {
    editable: false,
    main_obj: null,
    modification_callback_function:null,
    handler:{
        get: (target, key) => {
            if (typeof target[key] === "object" && target[key] !== null) {
                return new Proxy(target[key], menu.handler)
            }
            return target[key]
        },
        set: (target, prop, value) => {
            target[prop] = value
            menu.modified_dom(target, prop, value)
            return true
        }
    },
    modified_dom:(target, prop, value) =>{
        if(prop === 'length') return;
        const r = Object.keys(target)
        let a,b;
        if(r.indexOf(prop) === -1 ){ //handle specials.
            a = r.indexOf('_'+prop)
            b = target[prop]
        }else{ //handle the other ones.
            a = r.indexOf(prop)
            b = value;
        }
        const el = document.getElementById(target.menuid+'_'+a);
        if(el && !el.querySelector(`div[editor-type="float-special"]`)){
            el.parentNode.param.v = b;
            el.textContent = typeof b === 'number' ? b.toFixed(3) : b;
            if(menu.modification_callback_function) menu.modification_callback_function(target, prop, value);
        }
    },
    init: (name, obj, dom_element, callback=null) => {

        dom_element.appendChild(fantastic_menu);
        dom_element.appendChild(select_edit);
        // dom_element.appendChild(summary);
        menu.main_obj = obj;
        // modified_callback = modified_callback_f;
        Object.defineProperties(obj, {
            menuid: {
                value: 0,
                writable: false
            }
        });

        const root = element(name, null, obj, 'root', 0, 0, true);

        root.setAttribute('data-open', '1');

        fantastic_menu.appendChild(root);

        get_list(obj, 1).map(el => fantastic_menu.appendChild(el));

        refresh_list();

        selecta.re_fix();

        if(callback) menu.modification_callback_function = callback;

        return 'ok';
    },
    grope(){
        let element_counter = 0;
        function do_json_reorder(obj, to_obj, lvl = 0, index) {
            let ict = 0;
            const p_id = lvl > 0 ? indices[lvl - 1] : 0;
            let d_grope = Object.keys(obj);
            if(loader.ordering_dict.hasOwnProperty(element_counter)) {
                console.log('has order at', element_counter);
                d_grope = menu.ordering_dict[element_counter];
                console.log(d_grope, obj);
            }

            for (let c of d_grope) {
                indices[lvl] = element_counter;
                if(obj.hasOwnProperty('_'+c)) c = '_'+c; //#// prefer specials.
                if (typeof (obj[c]) === 'object' && obj[c]) {
                    to_obj[c] = Array.isArray(obj[c]) ? [] : {};
                    element_counter++;
                    do_json_reorder(obj[c], to_obj[c], lvl + 1);
                } else {
                    if(Array.isArray(to_obj)){
                        to_obj.push(obj[c]);
                    }else{
                        to_obj[c] = obj[c];
                    }
                    element_counter++;
                }
                ict++;
            }
        }
        const groped = {};
        do_json_reorder(menu.main_obj, groped, 0);
        return groped;
    },
    init_with_json: (obj, modified_callback_f = null, is_reload = null) => {
        document.body.appendChild(fantastic_menu);
        document.body.appendChild(select_edit);
        document.body.appendChild(summary);
        main_obj = obj;
        modified_callback = modified_callback_f;
        Object.defineProperties(obj, {
            id: {
                value: 0,
                writable: false
            }
        });
        const root = element('vars', null, obj, 'root', 0, 0, true);
        root.setAttribute('data-open', '1');
        fantastic_menu.appendChild(root);
        get_list(obj, 1).map(el => fantastic_menu.appendChild(el));

        refresh_list();

        selecta.re_fix();

        //console.log(menu.addresses);
    },
    update_from_addresses: (packet) => {
        log.log('delta addresses packet', packet[1]);
        console.log(main_obj);


        //#//set_object_from_array
        // const sofa = (obj, arr) => {
        //     return arr.length === 2 ? obj[arr[0]] = arr[1] : sofa(obj[arr.shift()], arr)
        // };

        for (let i in packet[0]) {
            const lex = i.split(':');
            const t_el = get_element(lex[0]);

            if (t_el) {
                let value = packet[0][i];
                let pass_down = null;

                if (Array.isArray(value)) {
                    value = value[1];
                    const to_name = t_el.param.pseudo ? value.slice(1, value.length) : value;
                    selecta.rename(t_el.param, to_name, 'is_restore');
                } else {
                    t_el.param[lex[1][0]] = value;

                    if (t_el.param.pseudo) {
                        t_el.param.obj[t_el.param.pseudo] = value;
                        pass_down = get_closest_special_attrib(t_el.firstChild, lex[2]);
                        pass_down.param.v = value;
                    } else {
                        t_el.param.obj[t_el.param.k] = value;
                    }
                }

                update_element(t_el);
                const pass_up = get_dom_parent(t_el);
                if (pass_up) update_element(pass_up);
                if (pass_down) update_element(pass_down);

                console.log('pass_down', pass_down);

            }

        }

    },
    ordering_dict: {},
    addresses: {},
    dragging_active: false,
    dragging_element: null,
    dragging_origin_after: null,
    cancel_dragging: () => {
        const t_el = menu.dragging_element.parentNode;
        [...t_el.children].map(c => c.classList.remove('drag-state'));
        menu.dragging_active = false;
        menu.dragging_origin_after.after(t_el);
    },
    refresh_list
}

window.addEventListener('mousemove', function(e){

    if(menu.dragging_active){
        e.preventDefault();
        const limits = menu.dragging_element.getBoundingClientRect();
        const dir = [['up',e.clientY < limits.top],['down',e.clientY > limits.bottom]].filter(d => d[1] === true);
        const element_row = menu.dragging_element.parentNode;
        // const rel_id = element_row.getAttribute('data-parent');
        if(dir[0]){
            if(dir[0][0] === 'up') {
                const pos = element_row.previousElementSibling.getAttribute('data-parent');
                if(!element_row.previousElementSibling || pos === 'root'){
                    menu.cancel_dragging();
                }else{
                    element_row.after(element_row.previousElementSibling);
                }
            }
            if(dir[0][0] === 'down') {
                if(!element_row.nextElementSibling) {
                    menu.cancel_dragging();
                }else{
                    element_row.before(element_row.nextElementSibling);
                }
            }
        }
    }
});


export {menu};